////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div>
    <span class="login-form-title">{{i18n.login.signin}}</span>
    <Form ref="loginData" :model="loginData" :rules="loginDataRules">
        <Form-item prop="phone">
          <!--Input type="text" v-model="loginData.login" placeholder="Телефон" icon="android-contact" size="large" class="input-left-icon"></Input-->
          <Input-Phone v-model="loginData.phone" style="color:#707a80;" nextTabElId="passwd" @blur="submitOnClick()"></Input-Phone>
        </Form-item>
        <Form-item prop="password">
          <Input type="password" v-model="loginData.password" :placeholder="i18n.login.password" icon="locked" size="large" class="input-left-icon"
           @on-enter="submitOnClick()" id="passwd"></Input>
        </Form-item>
        <Form-item>
          <Button type="primary" size="large" class="login-form-button" long @click="submitOnClick()">{{i18n.login.signin}}</Button>
          <Row class="login-form-links-group">
            <Col span="12" class="login-form-link text-align-center2"><router-link to="/welcome/signup">{{i18n.login.signup}}</router-link></Col>
            <Col span="12" class="login-form-link text-align-center2"><router-link to="/">На главную</router-link></Col>
            <!--Col span="12" class="login-form-link text-align-center2"><router-link to="/welcome/forgotPassword">{{i18n.login.forgotPassword}}</router-link></Col-->
          </Row>
      </Form-item>
    </Form>
  </div>
</template>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

import http from 'axios'
import mainCommonDataLoader from '../mainCommonDataLoader'

export default {
  name: 'SignIn',
  data () {
    return {
      loginData: {
        phone: '7',
        password: ''
      },

      tryingToLogin: false
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'i18n'
    ]),
    loginDataRules: function () {
      return {
        /* host: [
          { required: true, message: this.i18n.login.validations.fieldCannotBeEmpty, trigger: 'blur' }
        ], */
        phone: [
          { required: true, message: this.i18n.login.validations.fieldCannotBeEmpty, trigger: 'blur' },
          { type: 'string', min: 11, max: 11, message: 'Неверный номер телефона', trigger: 'blur' }
        ],
        // login: [
        //  { validator: function (rule, value, callback) { /* console.log('!!! login validator inside !!!!'); */ if (value === 1) return callback(new Error('Выберите пользователя не по умолчанию' /* this.i18n.login.validations.fieldCannotBeEmpty */)); callback() }, trigger: 'blur' }
        // ],
        password: [
          { required: true, message: this.i18n.login.validations.fieldCannotBeEmpty, trigger: 'blur' }
        ]
      }
    }
  },
  created: function () {
    // this.host = localStorage.getItem('BMSClientHost')
    this.loginData.phone = localStorage.getItem('BMSClientUser')
    // this.hostOnChange()
  },
  methods: {
    ...mapMutations([
      'appStateServerConnectedSet',
      'activeUserSet',
      'serverHostSet',
      'commonDataIsLoadedSet'
    ]),
    submitOnClick () {
      if (this.tryingToLogin === true) return
      this.tryingToLogin = true
      localStorage.setItem('BMSClientUser', this.loginData.phone)
      this.$refs['loginData'].validate((valid) => {
        if (valid) {
          var thisRef = this
          if (this.appSettings.server.host == null) {
            thisRef.$message.error('Ошибка при попытке обратиться к серверу: Сервер не известен')
            thisRef.tryingToLogin = false
            return
          }

          http.post(this.appSettings.server.userLogin, {phone: this.loginData.phone, password: this.loginData.password})
          .then(function (response) {
            // localStorage.setItem('BMSClient2017ActiveUser', JSON.stringify(response.data))
            thisRef.activeUserSet(response.data)
            thisRef.loginData.password = '' // трем перед тем как уйти со страницы welcome. тогда при возврате на нее пароль не будет доступен

            // еще раз перегружаем gettimeline c полной инфой (а следовательно и users) и settings. ну и заодно places
            thisRef.commonDataIsLoadedSet(false)
            mainCommonDataLoader({all: true}, function (error) {
              thisRef.tryingToLogin = false
              if (error) {
                console.log('>>>>>>> mainCommonDataLoader in Welcome component finished with ERROR: ' + error)
                if (error.response.status !== 400) {
                  thisRef.$message.error('Ошибка при попытке обратиться к серверу: ' + error.response.status + ', ' + JSON.stringify(error.response.data))
                } else {
                  thisRef.$message.error(error.response.data)
                }
              } else {
                // console.log('>>>>>>> mainCommonDataLoader finished')
                thisRef.commonDataIsLoadedSet(true)
                var lastLandPage = localStorage.getItem('lastLandPage')
                if (lastLandPage == null) lastLandPage = '/'
                thisRef.$router.push(lastLandPage)
              }
            })
          })
          .catch(function (error) {
            thisRef.tryingToLogin = false
            if (error.response === null) {
              thisRef.$message.error('Ошибка при попытке обратиться к серверу: Сервер не доступен')
              thisRef.appStateServerConnectedSet(false)
              thisRef.$router.push('/serverisnotavailable')
            } else {
              if (error.response.status !== 400) {
                thisRef.$message.error('Ошибка при попытке обратиться к серверу: ' + error.response.status + ', ' + JSON.stringify(error.response.data))
              } else {
                thisRef.$message.error(error.response.data)
              }
            }
          })
        } else {
          this.tryingToLogin = false
          // this.$message.error('Поля заполненны не верно')
        }
      })
    }
  }
}
</script>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
</style>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// SignIn.vue?1f215ade